import BaseExcelService from './BaseExcelService';

class PatientExcelService extends BaseExcelService {
  getBaseUrl() {
    return '~/api/excel/patient';
  }
}

export default new PatientExcelService();
